import { AnyAction } from 'redux';
import { AxiosError } from 'axios';
import { setRequestStatus } from 'data-layer-cr/dist/network';
import { ServerResponse } from 'data-layer-cr/dist/models';
import Inspection from 'src/models/responseTypes/Inspection';
import { AppThunk, AsyncAppThunk, AsyncDispatch } from '../../ThunkTypes';

import processRequest from '../../../services/processRequest';
import { SEARCH_INSPECTION, TRANSFER_INSPECTION } from '../requestIdentifier';
import { setInspections } from '../slice';
import { updateQuotationHistoryPage } from '../../steppers/slice';
import {
  GENERIC,
  TRANSFER_INSPECTION as TRANSFER_INSPECTION_ERROR,
} from '../../errorMsgs';

export function makeTransferError(error?: AxiosError): string {
  if (error && error.response && error.response.status === 400) {
    return TRANSFER_INSPECTION_ERROR;
  }
  return GENERIC;
}

export const updateInspections =
  (inspections: Inspection[]): AppThunk =>
  (dispatch): void => {
    dispatch(setInspections(inspections));
  };

export const getInspectionByLicense =
  (licensePlate: string): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(SEARCH_INSPECTION, 'requesting'));
    try {
      const { data } = await processRequest<ServerResponse<Inspection[]>>({
        method: 'GET',
        url: `Inspections/history/${licensePlate.toUpperCase()}`,
        uniqueIdentifier: SEARCH_INSPECTION,
        supressError: true,
      });

      dispatch(setInspections(data));

      return dispatch(setRequestStatus(SEARCH_INSPECTION, 'success'));
    } catch (e) {
      dispatch(setInspections([]));
      return dispatch(setRequestStatus(SEARCH_INSPECTION, 'failure'));
    }
  };

export const transferInspection =
  (urlSaltFrom: string): AsyncAppThunk =>
  async (dispatch: AsyncDispatch, getState): Promise<AnyAction> => {
    const { urlSalt: urlSaltTo } = getState().quotation.currentQuotation;
    dispatch(setRequestStatus(TRANSFER_INSPECTION, 'requesting'));
    try {
      await processRequest({
        method: 'POST',
        url: `Inspections/${urlSaltFrom}/transfer`,
        uniqueIdentifier: TRANSFER_INSPECTION,
        customErrorMessage: makeTransferError,
        data: {
          urlSaltTo,
        },
      });

      dispatch(setRequestStatus(TRANSFER_INSPECTION, 'success'));
      return dispatch(updateQuotationHistoryPage(0));
    } catch (e) {
      return dispatch(setRequestStatus(TRANSFER_INSPECTION, 'failure'));
    }
  };
